import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {NavService} from './nav-service';
import {EparcoursPath} from '../../constantes/menu/menu-items/eparcours-path';
import {PARAM_TOKEN} from './navigators/navigators';

@Injectable({
  providedIn: 'root',
})
export class RessourcesNavService extends NavService {
  constructor(router: Router) {
    super(router);
  }

  edition = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.RESSOURCES,
    EparcoursPath.ressources.EDITION,
    PARAM_TOKEN,
    EparcoursPath.ressources.EDITION_GENERAL,
  );

  creation = this.makeNavigator(EparcoursPath.root.RESSOURCES, EparcoursPath.ressources.CREATION);

  liste = this.makeNavigator(EparcoursPath.root.RESSOURCES);
}
